<script setup lang="ts">
import { useVModel } from '@vueuse/core'

import { type Currency, Form } from '~/layers/forms/models'

interface Props {
  modelValue: Currency
}

const props = defineProps<Props>()
const emits = defineEmits(['update:modelValue'])
const model = useVModel(props, 'modelValue', emits)
</script>

<template>
  <FormsGlobalContainer :identifier="Form.device">
    <FormsGlobalTitle
      text="Monto a asegurar"
      icon-class="icon-[ph--money-wavy-bold]"
    />

    <FormsGlobalCurrencyInput
      v-model="model"
      :validation-scope="Form.insuredAmount"
    />
  </FormsGlobalContainer>
</template>
